export const AFI_SUBDOMAINS = { AMFAM: 'amfam', AFI: 'afi' } as const;
export type AfiSubdomain = (typeof AFI_SUBDOMAINS)[keyof typeof AFI_SUBDOMAINS];

export const isAfiSubdomain = (subdomain: string): subdomain is AfiSubdomain =>
  Object.values(AFI_SUBDOMAINS).includes(subdomain as AfiSubdomain);
